// extracted by mini-css-extract-plugin
export var content = "_bx-3";
export var list = "_bx-4";
export var settingsContent = "_bx-7";
export var settingsPanel = "_bx-8";
export var state = "_bx-6";
export var triggerBadge = "_bx-2";
export var triggerButton = "_bx-1";
export var triggerShell = "_bx-0";
export var unreadDot = "_bx-5";